import { render } from "./ImportMatch.vue?vue&type=template&id=5b865690"
import script from "./ImportMatch.vue?vue&type=script&lang=js"
export * from "./ImportMatch.vue?vue&type=script&lang=js"

import "./ImportMatch.vue?vue&type=style&index=0&id=5b865690&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.26.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__